module.exports = __webpack_public_path__ + "img/bg_function05_1_m.343f600c.svg";